import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export type PickupDeliveryToggleMode = 'pickup' | 'delivery';

@Component({
  name: 'CmgPickupDeliveryToggle',
})
export default class CmgPickupDeliveryToggle extends Vue {
  @Prop({ required: true, default: true, type: Boolean })
  showPickup!: boolean;

  @Prop({ type: String, default: '' })
  pickId?: string;

  get deliveryIconUrl(): string {
    return this.$appStore.state.cms.images.icons.car.default;
  }

  get pepperSmallIconUrl(): string {
    return this.$appStore.state.cms.images.icons.pepperSmall.default;
  }

  onTogglePickupDelivery(mode: PickupDeliveryToggleMode) {
    this.$emit('toggle-pickup-delivery', mode);
  }

  get pickupLabel(): string {
    return this.showPickup ? 'selected' : 'Not selected';
  }

  get deliveryLabel(): string {
    return this.showPickup ? 'Not selected' : 'selected';
  }
}
